<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <table>
      <tr>
        <td class="pr-3">Name:</td>
        <td>{{ unlinkedCustomerInboxItem.first_name }} {{ unlinkedCustomerInboxItem.last_name }}</td>
      </tr>
      <tr>
        <td class="pr-3">Birthday:</td>
        <td>
          <span *ngIf="unlinkedCustomerInboxItem.birthday">{{ dateStringFromISO8601(unlinkedCustomerInboxItem.birthday) }}</span>
          <span *ngIf="!unlinkedCustomerInboxItem.birthday" class="text-muted">None</span>
        </td>
      </tr>
      <tr>
        <td class="pr-3 pt-3">Membership:</td>
        <td class="pt-3">{{ unlinkedCustomerInboxItem.membership_name }}</td>
      </tr>
      <tr>
        <td class="pr-3 pt-3">Purchased By:</td>
        <td class="pt-3">
          <a *ngIf="unlinkedCustomerInboxItem.owner_id"
             routerLink="/customers/{{ unlinkedCustomerInboxItem.owner_id }}/memberships-and-passes"
             target="_blank">
            {{ unlinkedCustomerInboxItem.owner_first_name }} {{ unlinkedCustomerInboxItem.owner_last_name }}
          </a>
          <span *ngIf="!unlinkedCustomerInboxItem.owner_id">
          {{ unlinkedCustomerInboxItem.owner_first_name }} {{ unlinkedCustomerInboxItem.owner_last_name }} (Pending)
          </span>
        </td>
      </tr>
      <tr>
        <td class="pr-3">Purchase Date:</td>
        <td>{{ dateStringFromISO8601(unlinkedCustomerInboxItem.purchased_at) }}</td>
      </tr>
      <ng-container *ngIf="unlinkedCustomerInboxItem.membership_is_group">
        <tr *ngIf="loadingCustomerMembership">
          <td class="pr-3 pt-3">Other Members:</td>
          <td class="pt-3 text-muted">Loading...</td>
        </tr>
        <ng-container *ngIf="!loadingCustomerMembership">
          <tr *ngFor="let otherCustomerName of getOtherCustomerNames(); let idx = index;">
            <td *ngIf="idx === 0" class="pr-3 pt-3">Other Members:</td>
            <td *ngIf="idx !== 0" class="pr-3"></td>
            <td [class.pt-3]="idx === 0">{{ otherCustomerName }}</td>
          </tr>
        </ng-container>
      </ng-container>
    </table>

    <div class="form-group mt-3">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="(selectedCustomer === null) && hasSearchInput()">

      <ng-container *ngIf="hasSearchInput()">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of customerList.results"
                (click)="selectCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <div class="form-check mt-4">
      <input class="form-check-input" type="radio" id="linkInput"
             [value]="Action.link" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="linkInput">
        Link membership to selected customer
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" id="createNewInput"
             [value]="Action.createNew" [(ngModel)]="selectedAction">
      <label class="form-check-label" for="createNewInput">
        Create new customer and link to membership
      </label>
    </div>

    <div class="alert alert-danger mb-0 mt-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>

  </div>

</ng-container>
